<template>
    <PageGroup>
        <router-view
            :company="selectedCompany"
        />
    </PageGroup>
</template>

<script>
    import { mapState } from 'vuex';
    import PageGroup from 'source/components/_generics/layouts/PageGroup.vue';

    export default {
        name: 'MemorandumsPageGroup',

        components: { PageGroup },

        computed: {
            ...mapState('auth', ['selectedCompany'])
        }
    };

</script>
